module.exports = __webpack_public_path__ + "img/telephone-tribute.e33ac211.jpg";